import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';

export type FrequencyCapActive = number;
export const FrequencyCapActiveUnknown: FrequencyCapActive = 0;
export const FrequencyCapActiveInactive: FrequencyCapActive = 1;
export const FrequencyCapActiveActive: FrequencyCapActive = 2;

export type FrequencyCapType = number;
export const FrequencyCapTypeUnknown: FrequencyCapType = 0;
export const FrequencyCapTypeAdserverCampaign: FrequencyCapType = 1;

export type FrequencyCapUnit = string;
export const FrequencyCapUnitDays: FrequencyCapUnit = 'Days';
export const FrequencyCapUnitHours: FrequencyCapUnit = 'Hours';

export interface IFrequencyCap {
  ID: number;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: string;
  Active: FrequencyCapActive;
  Type: FrequencyCapType;
  Limit: number;
  TimeToLive: string;
  AdserverCampaignID: number;
  DurationUnits?: FrequencyCapUnit;
  EditableDuration?: string;
  FrequencyTrackingKey: number;
  FrequencyTargetingKey: number;
}

export const transformFrequencyCap = transformModel<IFrequencyCap>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  Active: parseNumber(['Active']),
  Type: parseNumber(['Type']),
  Limit: parseNumber(['Limit']),
  TimeToLive: parseString(['TimeToLive']),
  AdserverCampaignID: parseNumber(['AdserverCampaignID']),
  FrequencyTrackingKey: parseNumber(['FrequencyTrackingKey']),
  FrequencyTargetingKey: parseNumber(['FrequencyTargetingKey']),
});

export enum FrequencyTrackingKey {
  UNKNOWN = 0,
  DEVICEID = 1,
  IP = 2,
}

export enum FrequencyTargetingKey {
  UNKNOWN = 0,
  IMPRESSION = 1,
  DURATION = 2,
  BID_WON = 3,
}
